import { http, httpFile } from './http_service';

// Generate invoices according to stakeholder for Admin or Staff
export function generate(data){
    return http().post('/invoices/generate', data);
}

// Get all invoices for Admin or Staff
export function getAllInvoices(data){
    return http().post('/invoices/get-all-invoices', data);
}
 /**
 * VsaRecipientCreatedTaxInvoice Export
 * First create file in temp folder
 * Then download and delete temp file
 * during from date & to date for Admin or Staff
 */
 export function download(data){
    return http().post('/invoices/download', data);
}
 /**
 * VsaRecipientCreatedTaxInvoice Export
 * First create file in temp folder
 * Then attached to email and send
 * during from date & to date for Admin or Staff
 */
 export function sendInvoice(data){
  return http().post('/invoices/send', data);
}



